<div
  *ngIf="visible && (nudgeConfig$ | async) as config"
  [class.dismissible]="config.dismissible"
  class="upgrade-nudge-container mb-3"
>
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex align-items-center flex-grow-1">
      <fa-icon
        [icon]="
          config.type === 'discover'
            ? ['fas', 'rocket']
            : config.type === 'upgrade'
              ? ['fas', 'star']
              : ['fas', 'sync-alt']
        "
        class="me-2 nudge-icon"
      ></fa-icon>
      <span class="nudge-text">
        {{ config.message }}
        <a
          [routerLink]="config.type === 'discover' ? ['/about/features'] : ['/subscriptions/options']"
          class="btn btn-link btn-xs btn-no-block p-0 ms-1"
        >
          <ng-container *ngIf="config.type === 'discover'">{{ "Learn more" | translate }}</ng-container>
          <ng-container *ngIf="config.type === 'upgrade'">{{ "View plans" | translate }}</ng-container>
          <ng-container *ngIf="config.type === 'renew'">{{ "Renew now" | translate }}</ng-container>
          <fa-icon [icon]="['fas', 'chevron-right']" class="ms-1 chevron-icon"></fa-icon>
        </a>
        <a
          *ngIf="config.type === 'upgrade'"
          [routerLink]="['/about/features']"
          class="btn btn-link btn-xs btn-no-block p-0 ms-1"
        >
          {{ "Discover features" | translate }}
          <fa-icon [icon]="['fas', 'chevron-right']" class="ms-1 chevron-icon"></fa-icon>
        </a>
      </span>
    </div>
    <button
      *ngIf="config.dismissible && visible"
      (click)="dismiss(config)"
      class="btn-close ms-3"
      aria-label="Close"
      type="button"
    ></button>
  </div>
</div>
